<template>
  <div v-if="about">
    <h3 class="mb-5">Partner Endorsement</h3>
    <div class="h4 mb-5">
      顯示於AboutUs頁面
    </div>

    <!-- items -->
    <PageCollapse v-for="(item, i) in about.partners" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Partner {{ i + 1 }}</h3>
      </template>
      <template v-slot:body>
        <!-- Endorsement -->
        <label class="form-item d-flex py-5">
          <h4 class="w-180px">Endorsement</h4>
          <div class="flex-grow-1 flex-basis-0">
            {{ item.endorsement }}
          </div>
        </label>
        <!-- Company Logo -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4>Company Logo</h4>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <div
              class="w-305px h-187px bg-contain bg-center"
              :style="{
                'background-image': `url(${item.logo})`,
                'background-size': 'contain',
              }"
            ></div>
          </div>
        </div>
      </template>
    </PageCollapse>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PageCollapse,
  },
};
</script>

<style></style>
